import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { usePermission } from '@/core/permissions';
import { inventoryDetailService } from '../services/inventoryDetail.service';

export function useInventoryDetail(id: string) {
  const { profile } = useAuth();
  const { can, isAdmin } = usePermission();
  const userId = profile?.id || '';
  const companyId = profile?.company_id || '';

  const itemQuery = useQuery({
    queryKey: ['inventory', 'detail', id, companyId],
    queryFn: () => inventoryDetailService.getInventoryDetail(id, userId, companyId),
    enabled: !!id && !!userId && !!companyId,
  });

  const historyQuery = useQuery({
    queryKey: ['inventory', 'detail', 'history', id, companyId],
    queryFn: () => inventoryDetailService.getTransactionHistory(id, userId, companyId),
    enabled: !!id && !!userId && !!companyId,
  });

  const warehouseStockQuery = useQuery({
    queryKey: ['inventory', 'detail', 'warehouse-stock', id, companyId],
    queryFn: () => inventoryDetailService.getWarehouseStock(id, companyId),
    enabled: !!id && !!companyId,
  });

  return {
    item: itemQuery.data ?? null,
    history: historyQuery.data ?? [],
    warehouseStock: warehouseStockQuery.data ?? [],
    isLoading: itemQuery.isLoading || historyQuery.isLoading || warehouseStockQuery.isLoading,
    isError: itemQuery.isError || warehouseStockQuery.isError,
    error: itemQuery.error,
    canUpdate: isAdmin || can('inventory', 'update'),
    canAdjustStock: isAdmin || can('inventory', 'approve') || can('inventory', 'update'),
    refetch: () => {
      itemQuery.refetch();
      warehouseStockQuery.refetch();
    },
  };
}

